// src/utils/appMode.js
import { useSyncExternalStore } from "react";

export const APP_MODES = {
  ADMIN: "admin",
  CUSTOMER: "customer",
};

const STORAGE_KEY = "stir_app_mode";
const MODE_CHANGE_EVENT = "stir-app-mode-change";

function subscribeToAppMode(onChange) {
  window.addEventListener(MODE_CHANGE_EVENT, onChange);
  window.addEventListener("storage", onChange);
  return () => {
    window.removeEventListener(MODE_CHANGE_EVENT, onChange);
    window.removeEventListener("storage", onChange);
  };
}

// Presentation only: never use this value to authorize operations or choose an identity.
export function useCustomerPresentation(role) {
  const mode = useSyncExternalStore(subscribeToAppMode, getStoredAppMode, () => null);
  const normalizedRole = String(role || "").toLowerCase();
  return normalizedRole === "user" ||
    (normalizedRole === "admin" && mode === APP_MODES.CUSTOMER);
}

export function getStoredAppMode() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === APP_MODES.ADMIN || value === APP_MODES.CUSTOMER) {
      return value;
    }
    return null;
  } catch {
    return null;
  }
}

export function setStoredAppMode(mode) {
  try {
    if (mode === APP_MODES.ADMIN || mode === APP_MODES.CUSTOMER) {
      localStorage.setItem(STORAGE_KEY, mode);
      window.dispatchEvent(new Event(MODE_CHANGE_EVENT));
    }
  } catch {
    // niente drammi
  }
}

export function clearStoredAppMode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(MODE_CHANGE_EVENT));
  } catch {
    // amen
  }
}

export function getEffectiveAppMode(user) {
  const role = String(user?.role || "").toLowerCase();

  if (role !== "admin") {
    return APP_MODES.CUSTOMER;
  }

  const stored = getStoredAppMode();
  return stored || APP_MODES.ADMIN;
}
